<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">

        <div class="vx-row mb-3">
          <div class="vx-col md:w-full md:mb-0">
            <ValidationProvider vid="is_enzymes_catalysts_used" name="is_enzymes_catalysts_used" rules="" v-slot="{ errors }">
              <small class="label">Are enzymes or catalysts used at any stage during the manufacturing process (including for any additives, preservatives, diluents, processing aids or solvents)?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_enzymes_catalysts_used" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
<!--          <div class="vx-col md:w-1/2 w-full md:mb-0">-->
<!--            <ValidationProvider v-if="form.is_enzymes_catalysts_used" vid="is_enzymes_catalysts_used_comment" name="is_enzymes_catalysts_used_comment" rules="required" v-slot="{ errors }">-->
<!--              <small class="label">If Yes, Give details</small>-->
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_enzymes_catalysts_used_comment" name="is_enzymes_catalysts_used_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
<!--            </ValidationProvider>-->
<!--          </div>-->
        </div>

        <vs-divider v-if="form.is_enzymes_catalysts_used" class="mt-8 mb-12" style="opacity: 0.2;" color="" position="center"/>

        <div v-if="form.is_enzymes_catalysts_used" v-for="(enzyme_catalyst, index) in form.enzyme_catalyst_item" :key="index" class="mt-8">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  :vid="index+'identity'" :name="index+'identity'" rules="required" v-slot="{ errors }">
                <small class="label">Identity of Enzyme / Catalyst</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="enzyme_catalyst.identity" name="identity" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  :vid="index+'source'" :name="index+'source'" rules="required" v-slot="{ errors }">
                <small class="label">Source Material</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="source" class="w-full" v-model="enzyme_catalyst.source" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>


          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider  :vid="index+'function'" :name="index+'function'" rules="required" v-slot="{ errors }">
                <small class="label">Function</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="function" class="w-full" v-model="enzyme_catalyst.function" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-1/2 md:mb-0">
              <ValidationProvider :vid="index+'is_present'" :name="index+'is_present'" rules="" v-slot="{ errors }">
                <small class="label">Present in Finished Product? </small>
                <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="enzyme_catalyst.is_present" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                  <span slot="on">Yes</span>
                  <span slot="off">No</span>
                </vs-switch>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/2 w-full md:mb-0">
              <ValidationProvider v-if="enzyme_catalyst.is_present" :vid="index+'is_present_comment'" :name="index+'is_present_comment'" rules="required" v-slot="{ errors }">
                <small class="label">If Yes, Give details</small>
                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="enzyme_catalyst.is_present_comment" name="is_present_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <vs-button :disabled="form.enzyme_catalyst_item.length === 1 && form.is_enzymes_catalysts_used" class="float-right mt-0 mb-8" @click="deleteEnzyme(index)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x">delete</vs-button>
            </div>
          </div>
          <vs-divider class="mt-4 mb-8" style="opacity: 0.2;" color="" position="center"/>
        </div>

        <vs-button v-if="form.is_enzymes_catalysts_used" @click="addEnzyme" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add enzyme catalyst item</vs-button>


        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_enzymes_compliant_regulations" name="is_enzymes_compliant_regulations" rules="" v-slot="{ errors }">
              <small class="label">Are all enzymes compliant with Regulation (EC) No 1332/2008 on food enzymes? </small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_enzymes_compliant_regulations" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_enzymes_compliant_regulations" vid="is_enzymes_compliant_regulations_comment" name="is_enzymes_compliant_regulations_comment" rules="required" v-slot="{ errors }">
              <small class="label">If Yes, Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_enzymes_compliant_regulations_comment" name="is_enzymes_compliant_regulations_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>

        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 md:mb-0">
            <ValidationProvider vid="is_dossier_evaluation" name="is_dossier_evaluation" rules="" v-slot="{ errors }">
              <small class="label">Has a dossier been submitted for the evaluation of this enzyme, for inclusion on the EU list of approved food enzymes, according to Regulation (EC) No 1332/2008? </small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_dossier_evaluation" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider v-if="form.is_dossier_evaluation" vid="is_dossier_evaluation_comment" name="is_dossier_evaluation_comment" rules="required" v-slot="{ errors }">
              <small class="label">If Yes, Comment</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_dossier_evaluation_comment" name="is_dossier_evaluation_comment" class="w-full"  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
            </ValidationProvider>
          </div>
        </div>



        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_enzymes_catalyst_complete"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

    export default {
        name: "SupplierManufacturingHome",
      data() {
          return {
            form: {
              is_enzymes_catalysts_used: false,
              is_enzymes_compliant_regulations: false,
              is_dossier_evaluation: false,
              enzyme_catalyst_item: [
                {identity: '', source: '', function: '', is_present: false, is_present_comment: ''}
              ]
            },
            id: null,
            status: {},
          }
      },
      mixins: [SuccessMessage, ErrorMessages],
      methods: {
        onClickNext() {
          this.$emit('notify', 1)
        },
        onClickSubmit() {
          this.status.is_raw_material_enzymes_catalyst_complete ? this.onClickUpdate() : this.onClickCreate()
        },

        async onClickUpdate() {
          this.$vs.loading()
          try {
            if (!this.form.is_enzymes_catalysts_used) {
              this.form.enzyme_catalyst_item = []
            }
            const data= (await SupplierRawMaterialRepository.UpdateRawMaterialEnzymesCatalysts(this.id, this.form))
            this.showSuccessMessage('Raw Material Enzymes & Catalysts Item Details Updated!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },
        async onClickCreate() {
          this.$vs.loading()
          try {
            if (!this.form.is_enzymes_catalysts_used) {
              this.form.enzyme_catalyst_item = []
            }
            const data= (await SupplierRawMaterialRepository.CreateRawMaterialEnzymesCatalysts(this.form))
            this.showSuccessMessage('Raw Material Enzymes & Catalysts Item Details Created!')
            this.onClickNext()
          }catch (e) {
            this.convertAndNotifyError(e)
          }
          this.$vs.loading.close()
        },

        async loadData() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialEnzymesCatalysts(this.id)).data
          this.form =data
          if (this.form.enzyme_catalyst_item.length === 0) {
            this.addEnzyme()
          }
          this.$vs.loading.close()
        },
        async loadStatus() {
          this.$vs.loading()
          const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
          this.status =data
          this.$vs.loading.close()
        },
        addEnzyme() {
          this.form.enzyme_catalyst_item.push(
            {identity: '', source: '', function: '', is_present: false, is_present_comment: ''}
          )
        },
        deleteEnzyme(index) {
          this.form.enzyme_catalyst_item.splice(index, 1)
        }
      },
      async mounted() {
        this.id = this.$route.params.id
        this.form.supplier_raw_material_id =  this.id
        await this.loadStatus()
        if (this.status.is_raw_material_enzymes_catalyst_complete) {
          await this.loadData()
        }
      }
    }
</script>

<style scoped>

</style>
